<script>
	import { onMount } from 'svelte';
	import SearchResultItem from './SearchResultItem.svelte';
	import SearchDashboard from './SearchDashboard.svelte';

	let photos = [];
	let results = [];
	let queryText;
	let pageStart = 1;
	let pageSize;
	let pageSizeDefault = 25;
	let totalResults;
	let loading = false;
	let loadMoreLoading = false;

	onMount(async () => {
		// need to get rid of # to make URL functionalities work
		let url = new URL(window.location.href.replace('#',''));
		queryText = url.searchParams.get('queryText');

		loading = true;
		doSearch().then((data) => {
			data.json().then(searchReceived).catch((err) => console.log(err));
		},(err) => handleError()).catch((err) => console.log(err));

	});
	function doSearch() {
		const fetchObj = {
			method: 'POST',
			// mode: 'no-cors',
			body: JSON.stringify({
				queryText: decodeURI(queryText),
				pageStart: pageStart,
				pageSize: pageSizeDefault
			}),
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Request-Method': 'POST',
				'Access-Control-Request-Headers': 'origin, x-requested-with',
			}
		}
		const api = 'ENVIRONMENT_DOMAIN/rest/search/xplore/help';

		return fetch(api,fetchObj);
	}
	function searchReceived(data) {
		totalResults = data.totalResults;
		results = data.results;
		loading = false;
	}
	function appendToRecords(data) {
		totalResults = data.totalResults;
		pageStart = data.pageStart;
		results = [...results, ...data.results];
		loadMoreLoading = false;
	}
	function handleLoadMore() {
		loadMoreLoading = true;
		pageStart++;
		doSearch().then((data) => {
			data.json().then(appendToRecords).catch((err) => console.log(err));
		},(err) => handleError()).catch((err) => console.log(err));
	}
	function handleError() {
		loading = false;
		loadMoreLoading = false;
	}
</script>

<style>
	* {
		font-family: sans-serif;
	}
   .fa-spinner {
	   color: #C3C3C3
   }
   .button-container {
	   display: flex;
	   justify-content: center;
   }
   .load-more-button {
	   background-color: #006699;
	   color: white;
	   font-size: 1rem;
	   padding: .5rem .5rem;
	   border-radius: 5px;
	   margin-top: 1rem;
   }
   .loader-container {
	   display: flex;
	   justify-content: center;
	   padding-right: 2rem;
	   padding-top: 3rem;
   }
</style>

<div class="search-results">
  {#if loading === true}
  <div class="loader-container">
	<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
	<span class="sr-only">Loading...</span>
  </div>
  {:else}
	<SearchDashboard
		queryText={queryText}
		pageStart={pageStart}
		pageSizeDefault={pageSizeDefault}
		totalResults={totalResults}
	/>
  {/if}

  {#each results as result }
	<SearchResultItem result={result}/>
  {/each}

  {#if totalResults > pageStart * pageSizeDefault && loadMoreLoading === false}
	<div class="button-container">
		<button class="load-more-button" on:click={handleLoadMore}>
			Load More
		</button>
	</div>
  {/if}
	{#if loadMoreLoading === true}
	<div class="loader-container">
		<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
	</div>
	{/if}
</div>
